import { useEffect, useState } from 'react';
import { useFragment, graphql } from 'react-relay';

import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';

import { type usePdpPricingAndSaleVariant_item$key } from './__generated__/usePdpPricingAndSaleVariant_item.graphql.ts';

const PRICING_AND_SALE_TEST_NAME = 'PDP_PricingANDSaleEnd_Sept2025';

const itemFragment = graphql`
    fragment usePdpPricingAndSaleVariant_item on Item {
        isSold
        isUnpurchasable
    }
`;

export const usePdpPricingAndSaleVariant = ({
    item: itemRef,
}: {
    item?: usePdpPricingAndSaleVariant_item$key | null;
}): boolean => {
    const item = useFragment(itemFragment, itemRef);
    const isUnavailable = item?.isSold || item?.isUnpurchasable;

    const [isVariant, setIsVariant] = useState<boolean>(false);

    useEffect(() => {
        setIsVariant(
            getAbTestV2(PRICING_AND_SALE_TEST_NAME)?.variant === 'variant' && !isUnavailable
        );
    }, [isUnavailable]);

    return isVariant;
};

export const useTrackPdpPricingAndSaleTest = ({
    item: itemRef,
}: {
    item?: usePdpPricingAndSaleVariant_item$key | null;
}): void => {
    const item = useFragment(itemFragment, itemRef);
    const isUnavailable = item?.isSold || item?.isUnpurchasable;

    useEffect(() => {
        if (!isUnavailable) {
            trackAbTestV2Variant(PRICING_AND_SALE_TEST_NAME);
        }
    }, [isUnavailable]);
};
